import { useMemo } from 'react';

import { ChangeNoteDialog } from '@shared/components';
import { bumpVersionComponent } from '@modules/items';
import { useCompleteLiterature } from '../../api';
import { TLiterature, TLiteratureVersion } from '../../types';

// Literature always bumps the minor component ("N.M" → "N.(M+1)"), matching inline blocks.
const getNextLiteratureVersionId = (versions: TLiteratureVersion[]): string =>
  versions[0]?.id ? bumpVersionComponent(versions[0].id, 1) : '0.1';

type TProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  literature: TLiterature;
};

const CompleteLiteratureDialog = ({ isOpen, setIsOpen, literature }: TProps) => {
  const complete = useCompleteLiterature();
  const nextVersionId = useMemo(() => getNextLiteratureVersionId(literature.versions), [literature]);

  return (
    <ChangeNoteDialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={`Complete version ${nextVersionId}`}
      onComplete={(note) => complete.mutateAsync({ id: literature._id, version: nextVersionId, note })}
    />
  );
};

export default CompleteLiteratureDialog;
